var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"id":"app-wrapper"}},[_c('top-nav-toolbar'),_c('v-content',{attrs:{"app":""}},[_c('router-view')],1),_c('bottom-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }